export function sanitize(params: any[]): any[] {
  return params.map((param) => {
    if (typeof param === "string") {
      return param.replace(/[\n\r]/g, " ");
    }
    return param;
  });
}

export function logDevHelp(...params: any[]) {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log("Dev help:", ...sanitize(params));
  }
}

//TODO: 07/04/2026 restore if condition to log only in dev & int after websocket debugging
export function log(...params: any[]) {
  // eslint-disable-next-line no-console
  console.log(...sanitize(params));
}

export function debug(...params: any[]) {
  // eslint-disable-next-line no-console
  console.debug(...sanitize(params));
}

export function warn(...params: any[]) {
  // eslint-disable-next-line no-console
  console.warn(...sanitize(params));
}

export function error(...params: any[]) {
  // We might want to log errors even in production, or maybe Coralogix handles it.
  // Given the existing pattern, let's keep it consistent or decide if error should always log.
  // If we want Coralogix to catch it, it must be logged to console.
  // eslint-disable-next-line no-console
  console.error(...sanitize(params));
}
